const routes = [
  // 患者首页
  {
    path: "/apppatient",
    name: 'apppatient',
    meta: {
      title: '患者',
      hasBack: false
    },
    component: () => import('@/pages/medical/patientManagement/patient.vue'),
  },
  {
    path: "/apppatient/detail",
    name: 'apppatient/detail',
    meta: {
      title: '患者详情',
      hasBack: false
    },
    component: () => import('@/pages/medical/patientManagement/patientDetail/illnessDetail.vue'),
  },
];
export default routes;